module.exports = __webpack_public_path__ + "img/InsNichts.cd2533b9.jpg";